
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M96.5 116v21.2h29.1c-3.6 13.8-15.9 20.9-28.7 20.9-17.6 0-31.9-14.3-31.9-31.9s14.3-31.9 31.9-31.9c7.5 0 14.8 2.6 20.6 7.5L133.6 85c-10.1-9-23.2-14-36.7-14-30.4 0-55.2 23.6-55.2 55.2-.3 30.2 24 54.9 54.2 55.2h.9c32 0 51.2-21.8 52.2-48.3.3-7.2 0-17.1 0-17.1H96.5zm103.4-22.5h-16v22.6h-22.5v16h22.5v22.6h16v-22.6h22.6v-16h-22.6V93.5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M128 0C57.8.5 1.3 57.8 1.8 128s57.8 126.7 128 126.2c69.5-.5 125.7-56.7 126.2-126.2C256 57.3 198.7 0 128 0m21.1 133c-1 26.5-20.2 48.3-52.2 48.3-30.2.3-54.9-24-55.2-54.2v-.9C41.8 94.6 66.6 71 96.9 71c13.5 0 26.6 5 36.7 14l-16.2 16.7c-13.5-11.3-33.6-9.6-45 3.9s-9.6 33.6 3.9 45c5.7 4.8 13 7.5 20.5 7.5 12.8 0 25-7.1 28.7-20.9h-29V116h52.6s.3 9.9 0 17m73.4-.9h-22.6v22.6H184v-22.6h-22.6v-16H184V93.5h16v22.6h22.6l-.1 16z"}})])
          )
        }
      }
    